<template>
  <v-dialog v-model="dialog" persistent max-width="600">
    <template v-slot:activator="{ on }">
      <v-btn v-on="on" outlined color="error" class="mr-3" title="bloquear">
        <v-icon>mdi-cancel</v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-card-title class="modal-header elevation-10">
        <v-row>
          <v-col>
            <slot name="title">Bloquear Usuário</slot>
          </v-col>
          <v-col class="text-right">
            <v-icon @click="dialog = false" color="white"
              >mdi-window-close</v-icon
            >
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col>
            <h2>Deseja realmente bloquear o usuário?</h2>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            Ao bloquear um usuário, você irá impossibilita-lo de fazer login no
            sistema.
          </v-col>
        </v-row>
        <v-row>
          <v-col>Nome : {{ usuario.nome }}</v-col>
        </v-row>
        <v-row>
          <v-col>Email : {{ usuario.email }}</v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <div class="flex-grow-1"></div>
        <v-btn color="error" text @click="dialog = false">Cancelar</v-btn>
        <v-btn color="info" @click="onConfirm">Bloquear</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { userAPI } from "./UserAPI";
import { mapActions } from "vuex";

export default {
  name: "AppModalConfirmStopSolution",
  props: {
    usuario: { type: Object, required: true },
  },
  data() {
    return {
      dialog: false,
    };
  },
  methods: {
    ...mapActions(["setLoading"]),
    onConfirm() {
      this.setLoading(true);
      let user = {
        ...this.usuario,
        habilitado: false,
      };
      userAPI
        .habilitarDesabilitarUser(user)
        .then((resp) => {
          this.dialog = false;
          this.$emit("onCloseModal");
          this.setLoading(false);
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao atualizar usuário");
        });
    },
  },
};
</script>
